import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Image extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/daytoday/image';

    /**
     *
     * @type {string}
     */
    static entity = 'packageDaytodayImages';

    static fields() {
		return {
			id: this.number(null).nullable(),
			public_image_id: this.number(null).nullable(),
			package_daytoday_id: this.number(null).nullable(),
			sort_order: this.number(null).nullable(),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .where('is_active', true)
            .get(true);
    }

    /**
     *
     * @returns {boolean|*}
     */
    PublicImage(){
        return this.getRelated('publicImage');
    }
}
